import * as React from "react";
const Video = (props) => (
  <svg
    width={12}
    height={10}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.51002 9.85608H3.18316C1.23746 9.85608 0.546875 8.49135 0.546875 7.2198V2.78032C0.546875 0.883955 1.28679 0.144043 3.18316 0.144043H6.51002C8.40639 0.144043 9.1463 0.883955 9.1463 2.78032V7.2198C9.1463 9.11617 8.40639 9.85608 6.51002 9.85608ZM3.18316 0.97713C1.75266 0.97713 1.37996 1.34983 1.37996 2.78032V7.2198C1.37996 7.89394 1.61564 9.02299 3.18316 9.02299H6.51002C7.94052 9.02299 8.31322 8.6503 8.31322 7.2198V2.78032C8.31322 1.34983 7.94052 0.97713 6.51002 0.97713H3.18316Z"
      fill="#ff6a4b"
    />
    <path
      d="M10.8395 8.34872C10.6039 8.34872 10.3024 8.27199 9.95713 8.03083L8.49375 7.00591C8.38413 6.92918 8.31836 6.80312 8.31836 6.6661V3.33376C8.31836 3.19673 8.38413 3.07068 8.49375 2.99394L9.95713 1.96903C10.6093 1.51412 11.0862 1.64566 11.3109 1.76076C11.5356 1.88133 11.9193 2.19374 11.9193 2.98846V7.00591C11.9193 7.80064 11.5356 8.11852 11.3109 8.23362C11.2068 8.29391 11.0423 8.34872 10.8395 8.34872ZM9.14597 6.44687L10.434 7.34573C10.6806 7.51563 10.856 7.53207 10.9272 7.49371C11.004 7.45534 11.0862 7.30188 11.0862 7.00591V2.99394C11.0862 2.6925 10.9985 2.54452 10.9272 2.50615C10.856 2.46778 10.6806 2.48423 10.434 2.65413L9.14597 3.55299V6.44687Z"
      fill="#ff6a4b"
    />
    <path
      d="M5.7537 4.86286C5.07407 4.86286 4.52051 4.3093 4.52051 3.62967C4.52051 2.95005 5.07407 2.39648 5.7537 2.39648C6.43332 2.39648 6.98688 2.95005 6.98688 3.62967C6.98688 4.3093 6.43332 4.86286 5.7537 4.86286ZM5.7537 3.21861C5.52898 3.21861 5.34263 3.40496 5.34263 3.62967C5.34263 3.85439 5.52898 4.04073 5.7537 4.04073C5.97841 4.04073 6.16476 3.85439 6.16476 3.62967C6.16476 3.40496 5.97841 3.21861 5.7537 3.21861Z"
      fill="#ff6a4b"
    />
  </svg>
);
export default Video;
